import { parse } from 'qs';
import { UserFullQuotaWeightlessAPICall } from 'reactApp/api/user/FullQuotaAPICall';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { sendDwh } from 'reactApp/utils/ga';
import { disappearPlural } from 'reactApp/utils/pluralHelpers';

export const getBazFilesSize = async (): Promise<number> => {
    const { data } = await new UserFullQuotaWeightlessAPICall().makeRequest();
    return data.body.weightless_size;
};
export const bazImageUrl = `${cdnPackagesUrl}/static/cloud/card-unlink/unlimited-upload-card-unlink@2x.png`;
export const bazImageMobileUrl = `${cdnPackagesUrl}/static/cloud/card-unlink/unlimited-upload-card-unlink-mobile.png`;
export const getSpaceLossText = (space: { value: string; space: number }) => {
    const verb = disappearPlural(space.space);
    return `${verb[0].toUpperCase()}${verb.slice(1)} ${space.value}`;
};

export const sendCardUnlinkOutflowAnalytics = (action: string, name: string, buttonName?: string, platform = 'web') => {
    sendDwh({
        action,
        eventCategory: 'modal',
        dwh_enabled: true,
        dwhData: {
            name,
            platform,
            ...(buttonName ? { button_name: buttonName } : {}),
        },
    });
};

export const shouldShowCardModal = (): boolean => {
    if (typeof window !== 'undefined' && window.location.search) {
        const { action } = parse(window.location.search, { ignoreQueryPrefix: true });

        if (action === 'add-card') {
            return true;
        }
    }

    return getQueryParams()?.action === 'add-card';
};
